if (!window.customElements.get('sticky-banner')) {
  class StickyBanner extends HTMLElement {
    constructor() {
      super();

      this.deviceType = this.dataset.deviceType;
      this.connectedElementSelector = this.dataset.connectedElement;
      this.hiddenOnElementsSelectors = this.dataset.hiddenOnElements;

      this.observer = null;

      this._setBannerVisibility = this.setBannerVisibility.bind(this);
    }

    get connectedElement() {
      return document.querySelector(this.connectedElementSelector) || null;
    }

    get hiddenOnElements() {
      return document.querySelectorAll(this.hiddenOnElementsSelectors);
    }

    get footerElement() {
      return document.querySelector('.footer, .footer-alt');
    }

    connectedCallback() {
      this.init();
      this.createIntersectionObserver();
      this.observeHiddenElements();
    }

    disconnectedCallback() {
      this.destroy();
      this.observer?.disconnect();
    }

    init() {
      if (!this.connectedElement) return;

      this.setBannerVisibility();
      window.addEventListener('scroll', this._setBannerVisibility)
    }

    destroy() {
      window.removeEventListener('scroll', this._setBannerVisibility)

      this.classList.add('sticky-cta-banner--hidden');
    }

    validateDeviceType() {
      switch (this.deviceType) {
        case 'mobile':
          return window.innerWidth < 768

        case 'desktop':
          return window.innerWidth >= 768 
          
        case 'both':
          return true;
      }
    }

    createIntersectionObserver() {
      if (!this.hiddenOnElements?.length) return;

      const options = { threshold: 0.1 };
      const onEntry = (entries) => {
        entries.forEach(entry => {
          this.classList.toggle('sticky-cta-banner--hidden-on-element', entry.isIntersecting);
        });
      };

      this.observer = new IntersectionObserver(onEntry, options);
    }

    observeHiddenElements() {
      if (!this.observer) return;

      this.hiddenOnElements.forEach((element) => {
        this.observer.observe(element)
      })
    }

    setBannerVisibility() {
      const { top: connectedElementScrollPosition } = this.connectedElement?.getBoundingClientRect() || null;
      if (connectedElementScrollPosition === null) return;

      const { top: footerElementScrollPosition } = this.footerElement?.getBoundingClientRect() || null;
      const isFooterShown = footerElementScrollPosition && (footerElementScrollPosition - window.innerHeight) <= 0;

      if (!this.validateDeviceType()) {
        this.classList.add('sticky-cta-banner--hidden');
        return;
      }

      if (isFooterShown) {
        this.classList.add('sticky-cta-banner--hidden');
        return;
      }

      this.classList.toggle('sticky-cta-banner--hidden', connectedElementScrollPosition > 0);
    }
  }

  window.customElements.define('sticky-banner', StickyBanner)
}